/* tslint:disable */
/* eslint-disable */
/**
 * PCO - Product & Services
 * API to test if access the application and get the current version
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * Contains the document distribution information
 * @export
 * @interface DocumentDeliveryResponse
 */
export interface DocumentDeliveryResponse {
    /**
     * returns the distribution request id - unique key to identify the email in PCD
     * @type {string}
     * @memberof DocumentDeliveryResponse
     */
    distributionRequestId?: string;
}

/**
 * Check if a given object implements the DocumentDeliveryResponse interface.
 */
export function instanceOfDocumentDeliveryResponse(value: object): value is DocumentDeliveryResponse {
    return true;
}

export function DocumentDeliveryResponseFromJSON(json: any): DocumentDeliveryResponse {
    return DocumentDeliveryResponseFromJSONTyped(json, false);
}

export function DocumentDeliveryResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): DocumentDeliveryResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'distributionRequestId': json['distributionRequestId'] == null ? undefined : json['distributionRequestId'],
    };
}

export function DocumentDeliveryResponseToJSON(json: any): DocumentDeliveryResponse {
    return DocumentDeliveryResponseToJSONTyped(json, false);
}

export function DocumentDeliveryResponseToJSONTyped(value?: DocumentDeliveryResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'distributionRequestId': value['distributionRequestId'],
    };
}

